import { useEffect, useMemo, useState } from "react";

import axios from "axios";

import {
  Calendar,
  Target,
  Wallet,
  TrendingUp,
  BadgeDollarSign,
  Megaphone,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  Plus,
  Camera,
    MoreVertical,
  Download,
  Trash2,
  ClipboardList,
  UserPlus,
  Trophy,
} from "lucide-react";


import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const COLORS = [
  "#6366f1",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
];

export default function MarketingDashboard() {
  // =========================
  // STATE
  // =========================

  const today = new Date();

  const [loading, setLoading] =
    useState(false);

    const [submitLoading, setSubmitLoading] = useState(false);

    // State Galeri Aktivitas
const [showGalleryModal, setShowGalleryModal] = useState(false);
// State Baru Khusus Modal Galeri View Only (Tanpa Upload)
const [showViewGalleryModal, setShowViewGalleryModal] = useState(false);
const [viewGalleryEvent, setViewGalleryEvent] = useState(null);
const [viewActiveImage, setViewActiveImage] = useState(null); // Untuk zoom/lightbox foto
const [selectedGalleryEvent, setSelectedGalleryEvent] = useState(null);
const [galleryImages, setGalleryImages] = useState([]);
const [isLoadingGallery, setIsLoadingGallery] = useState(false);
const [galleryForm, setGalleryForm] = useState({ keterangan: "", foto_file: null });
const [galleryPreview, setGalleryPreview] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [activeLightboxImage, setActiveLightboxImage] = useState(null);
const [selectedEvents, setSelectedEvents] = useState([]);
const [showModal, setShowModal] = useState(false);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null);
const [showQR, setShowQR] = useState(false);
const [openAction, setOpenAction] = useState(null);
const [showAddEvent, setShowAddEvent] = useState(false);

// State untuk Modal & Penggunaan Budget
const [showBudgetModal, setShowBudgetModal] = useState(false);
const [selectedBudgetEvent, setSelectedBudgetEvent] = useState(null);
const [budgetHistory, setBudgetHistory] = useState([]);
const [isLoadingHistory, setIsLoadingHistory] = useState(false);


const [budgetForm, setBudgetForm] = useState({
  biaya: "",
  tipe_pembayaran: "CASH",
  keterangan: "",
  bukti_file: null 
});
const [buktiPreview, setBuktiPreview] = useState(null);

// 1. FUNGSI AMBIL HISTORY DARI BACKEND
const fetchBudgetHistory = async (id_pengajuan) => {
  setIsLoadingHistory(true);
  try {
    // Sesuaikan URL endpoint dengan routing backend Anda
    const response = await axios.get(`/api/marketing/budget-history?id_pengajuan=${id_pengajuan}`);
    if (response.data.success) {
      setBudgetHistory(response.data.data);
    }
  } catch (error) {
    console.error("Gagal mengambil history budget:", error);
    alert("Gagal memuat riwayat penggunaan budget");
  } finally {
    setIsLoadingHistory(false);
  }
};

// 2. FUNGSI HANDLE FILE UPLOAD & PREVIEW


// 3. FUNGSI SUBMIT FORM (POST KE BACKEND)
const handleBudgetSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const formData = new FormData();
    formData.append("id_pengajuan", selectedBudgetEvent.id_pengajuan);
    formData.append("kode_toko", selectedBudgetEvent.kode_toko || "ALL");
    formData.append("biaya", budgetForm.biaya);
    formData.append("tipe_pembayaran", budgetForm.tipe_pembayaran);
    formData.append("keterangan", budgetForm.keterangan);
    if (budgetForm.bukti_file) {
      formData.append("bukti_pembiayaan", budgetForm.bukti_file);
    }

    // Ganti dengan endpoint simpan/create penggunaan budget Anda
    const response = await axios.post("/api/marketing/budget-use", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (response.data.success) {
      alert("Penggunaan budget berhasil disimpan!");
      // Reset Form
      setBudgetForm({ biaya: "", tipe_pembayaran: "CASH", keterangan: "", bukti_file: null });
      setBuktiPreview(null);
      // Refresh history biar langsung muncul yang baru
      fetchBudgetHistory(selectedBudgetEvent.id_pengajuan);
    }
  } catch (error) {
    console.error("Gagal menyimpan penggunaan budget:", error);
    alert(error.response?.data?.message || "Terjadi kesalahan sistem");
  }
};




const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setBudgetForm({ ...budgetForm, bukti_file: file });
    // Membuat preview jika file berupa gambar
    if (file.type.startsWith("image/")) {
      setBuktiPreview(URL.createObjectURL(file));
    } else {
      setBuktiPreview("pdf-icon"); // Penanda jika filenya PDF/bukan gambar
    }
  }
};


// 1. Ambil list foto dari backend
const fetchGalleryAktivitas = async (id_pengajuan) => {
  setIsLoadingGallery(true);
  try {
    const response = await axios.get(`/api/marketing/aktivitas-gallery?id_pengajuan=${id_pengajuan}`);
    if (response.data.success) {
      setGalleryImages(response.data.data);
    }
  } catch (error) {
    console.error("Gagal memuat galeri:", error);
  } finally {
    setIsLoadingGallery(false);
  }
};

// 2. Handle file gambar dipilih
const handleGalleryFileChange = (e) => {
  const file = e.target.files[0];
  if (file && file.type.startsWith("image/")) {
    setGalleryForm({ ...galleryForm, foto_file: file });
    setGalleryPreview(URL.createObjectURL(file));
  } else {
    alert("Format file wajib gambar/foto!");
  }
};

// 3. Submit kirim ke backend
const handleGallerySubmit = async (e) => {
  e.preventDefault();
  if (!galleryForm.foto_file) return alert("Silakan pilih foto terlebih dahulu");

  try {
    const formData = new FormData();
    formData.append("id_pengajuan", selectedGalleryEvent.id_pengajuan);
    formData.append("kode_toko", selectedGalleryEvent.kode_toko || "ALL");
    formData.append("keterangan", galleryForm.keterangan);
    formData.append("foto_aktivitas", galleryForm.foto_file);

    const response = await axios.post("/api/marketing/aktivitas-gallery", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (response.data.success) {
      alert("Foto aktivitas berhasil ditambahkan!");
      setGalleryForm({ keterangan: "", foto_file: null });
      setGalleryPreview(null);
      fetchGalleryAktivitas(selectedGalleryEvent.id_pengajuan); // Refresh daftar gambar
    }
  } catch (error) {
    console.error("Gagal mengunggah foto:", error);
    alert("Terjadi kesalahan saat mengunggah foto.");
  }
};

const [form, setForm] = useState({
  id_pengajuan: "",
  nama_event: "",
  kategori: "JOIN PROMO",
  start_date: "",
  end_date: "",
  pic: "SALES",
  voucher: "",

  budget: 0,
  netto: 0, // target
  budget_produk: 0,

  target_voucher_kembali: 0,
  target_pcs: 0,

  teknis_promo: "SCAN_QR",
  benefit: "",

  basket_size: 0,
  price_point: 0,

  lokasi_penyebaran: "",
  target_traffic: 0,
  harga_satuan: 0,

  goals: "",

  // ✅ tambahan field baru (pencairan / transfer)
  tujuan_pencairan: "",
  nama_penerima_tf: "",
  bank_penerima: "",
  nomor_rekening_penerima: "",
});
const [qrUrl, setQrUrl] = useState("");

  const [currentDate, setCurrentDate] =
    useState(new Date());

 // Fungsi pembantu untuk format tanggal ke YYYY-MM-DD sesuai waktu lokal
const formatLocalDate = (date) => {
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split("T")[0];
};

// Ambil tanggal pertama dan terakhir di bulan berjalan
const getInitialDates = () => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  
  return {
    from: formatLocalDate(firstDay),
    to: formatLocalDate(lastDay)
  };
};

const initialDates = getInitialDates();

// Set state menggunakan tanggal dinamis bulan berjalan
const [dateFrom, setDateFrom] = useState(initialDates.from);
const [dateTo, setDateTo] = useState(initialDates.to);

  const [marketingCalendar, setMarketingCalendar] =
    useState([]);

  const [summary, setSummary] =
    useState({
      totalBudget: 0,
      budgetPlan: 0,
      realization: 0,
      revenue: 0,
      target: 0,
      acquisition_revenue: 0,
    });

  const [trendData, setTrendData] =
    useState([]);

  const [categoryData, setCategoryData] =
    useState({
      promo: [],
      event: [],
      store: [],
      popup: [],
    });

  // =========================
  // FETCH API
  // =========================

  const hasOngoingEvent = (events) => {
  const today = new Date();

  return events.some((event) => {
    const start = new Date(event.start_date);
    const end = new Date(event.end_date);

    return today >= start && today <= end;
  });
};

  const getMarketingPlan = async () => {
    try {
      setLoading(true);
 const kode_toko = localStorage.getItem("kode_toko");
      const res = await axios.get(
        "/api/marketing/marketing-plan",
        {
          params: {
            kode_toko: kode_toko,
            dateFrom,
            dateTo,
          },
        }
      );

      const data = res.data;

      // =========================
      // SUMMARY
      // =========================

      setSummary({
        totalBudget:
          data.summary.total_budget || 0,

        budgetPlan:
          data.summary.total_budget || 0,

        realization:
          data.summary.realization || 0,

        revenue:
          data.summary.revenue || 0,

        acquisition_revenue:
          data.summary.acquisition_revenue || 0,

        target:
          data.summary.total_target || 0,
      });

      // =========================
      // CALENDAR
      // =========================

      setMarketingCalendar(
        data.calendar || []
      );

      // =========================
      // TREND
      // =========================

      setTrendData(
        data.trend?.map((item) => ({
          date: item.date,
          budget: Number(item.budget),
          revenue: Number(item.revenue),
        })) || []
      );

      // =========================
      // CATEGORY
      // =========================

      setCategoryData({
        promo: data.category.promo,
        event: data.category.event,
        store: data.category.store,
        popup: data.category.popup,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMarketingPlan();
  }, [dateFrom, dateTo]);

  // =========================
  // FORMAT
  // =========================
const getActiveEventsOnDate = (date) => {
  return marketingCalendar.filter((event) => {
    const start = new Date(event.start_date);
    const end = new Date(event.end_date);

    return date >= start && date <= end;
  });
};

const getGreenIntensity = (count) => {
  if (count === 0) return "";
  if (count === 1) return "bg-green-50 border-green-200";
  if (count === 2) return "bg-green-100 border-green-300";
  if (count === 3) return "bg-green-200 border-green-400";
  return "bg-green-300 border-green-500";
};
 const generateIdPengajuan = () => {
  const timestamp = Date.now(); // milidetik sejak 1970
  const random = Math.floor(100 + Math.random() * 900); // biar aman dari collision

  return `${timestamp}`;
};

  const getQrLink = (id_pengajuan) => {
  return `https://3secondmember.com/event?event_id=${id_pengajuan}`;
};

  const formatRupiah = (num) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(num || 0);

  // =========================
  // ACHIEVEMENT
  // =========================

  const achievement =
    summary.target > 0
      ? (summary.revenue /
          summary.target) *
        100
      : 0;

  // =========================
  // STATS
  // =========================

  const stats = [
  {
    label: "Total Budget",
    value: formatRupiah(summary.totalBudget),
    icon: Wallet,
    color: "from-indigo-500 to-blue-500",
  },

  {
    label: "Budget Plan",
    value: formatRupiah(summary.budgetPlan),
    icon: ClipboardList,
    color: "from-orange-500 to-yellow-500",
  },

  {
    label: "Realisasi Budget",
    value: formatRupiah(summary.realization),
    icon: CheckCircle2,
    color: "from-green-500 to-emerald-500",
  },

  {
    label: "Revenue",
    value: formatRupiah(summary.revenue),
    icon: TrendingUp,
    color: "from-cyan-500 to-sky-500",
  },

  {
    label: "Revenue (Acquisition)",
    value: formatRupiah(summary.acquisition_revenue),
    icon: UserPlus,
    color: "from-teal-500 to-emerald-500",
  },

  {
    label: "Target",
    value: formatRupiah(summary.target),
    icon: Target,
    color: "from-violet-500 to-fuchsia-500",
  },

  {
    label: "Achievement",
    value: `${achievement.toFixed(1)}%`,
    icon: Trophy,
    color: "from-rose-500 to-red-500",
  },
];

  // =========================
  // CALENDAR
  // =========================

  const handleSubmit = async () => {
  if (submitLoading) return;

  try {
    setSubmitLoading(true);

    const kode_toko = localStorage.getItem("kode_toko");

    await axios.post("/api/marketing/marketing-plan", {
      ...form,
      kode_toko,
    });

    setShowAddEvent(false);
    getMarketingPlan();
  } catch (err) {
    console.error(err);
  } finally {
    setSubmitLoading(false);
  }
};



  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
  ];

  const year =
    currentDate.getFullYear();

  const month =
    currentDate.getMonth();

  const firstDayOfMonth =
    new Date(year, month, 1);

  const lastDayOfMonth =
    new Date(year, month + 1, 0);

  const totalDays =
    lastDayOfMonth.getDate();

  const startDay =
    firstDayOfMonth.getDay();

  const calendarDays = [];

  for (let i = 0; i < startDay; i++) {
    calendarDays.push(null);
  }

  for (let d = 1; d <= totalDays; d++) {
    calendarDays.push(d);
  }

  const prevMonth = () => {
    setCurrentDate(
      new Date(year, month - 1, 1)
    );
  };

  const nextMonth = () => {
    setCurrentDate(
      new Date(year, month + 1, 1)
    );
  };

  useEffect(() => {
  const close = () => setOpenAction(null);

  window.addEventListener("click", close);

  return () =>
    window.removeEventListener("click", close);
}, []);

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return d.toLocaleDateString("id-ID", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};


 const handleDateClick = (day, events) => {
  if (!day) return;

  const clickedDate = new Date(year, month, day);

  setSelectedDate(clickedDate);
  setSelectedEvents(events || []);
  setShowModal(true);
};

  // =========================
  // PIE CARD
  // =========================

  const PieCard = ({
    title,
    value,
    percent,
    color,
    icon: Icon,
    data,
  }) => {
    return (
      <div
        className="
          rounded-3xl border border-gray-100
          p-4 bg-gradient-to-br from-white to-gray-50
        "
      >
        <div className="flex items-center justify-between mb-3">

          <div>
            <p className="text-xs text-gray-400 uppercase font-semibold">
              {title}
            </p>

            <h3 className="text-xl font-bold text-gray-800 mt-1">
              {value}
            </h3>
          </div>

          <div
            className="w-10 h-10 rounded-2xl text-white flex items-center justify-center"
            style={{
              background: color,
            }}
          >
            <Icon size={18} />
          </div>

        </div>

        <ResponsiveContainer
          width="100%"
          height={100}
        >
          <PieChart>

            <Pie
              data={data}
              dataKey="value"
              innerRadius={26}
              outerRadius={40}
              paddingAngle={3}
            >

              <Cell fill={color} />

              <Cell fill="#E5E7EB" />

            </Pie>

          </PieChart>
        </ResponsiveContainer>

        <div className="text-center -mt-2">

          <span
            className="text-sm font-semibold"
            style={{
              color,
            }}
          >
            {percent}%
          </span>

        </div>
      </div>
    );
  };

  return (
    <div className="p-6 min-h-screen">

      {/* HEADER */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">

        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            Marketing Plan
          </h1>
          

          <p className="text-sm text-gray-500 mt-1">
            Monitor budget, campaign &
            revenue performance
          </p>
        </div>

        {/* FILTER */}
        <div className="flex gap-3 flex-wrap">

          <div className="bg-white border rounded-xl px-4 py-2 shadow-sm flex items-center gap-2">

            <Calendar size={16} />

            <input
              type="date"
              value={dateFrom}
              onChange={(e) =>
                setDateFrom(
                  e.target.value
                )
              }
              className="outline-none text-sm"
            />

          </div>

          <div className="bg-white border rounded-xl px-4 py-2 shadow-sm flex items-center gap-2">

            <Calendar size={16} />

            <input
              type="date"
              value={dateTo}
              onChange={(e) =>
                setDateTo(
                  e.target.value
                )
              }
              className="outline-none text-sm"
            />

          </div>

        </div>
      </div>

      {/* STATS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-7 gap-4">

  {stats.map((item, i) => {
    const Icon = item.icon;

    return (
      <div
        key={i}
        className="
          bg-white rounded-2xl
          p-4 border border-gray-100
          shadow-sm hover:shadow-md
          transition-all duration-300
        "
      >
        <div className="flex items-start justify-between">

          <div>
            <p className="text-[10px] uppercase tracking-wide text-gray-400 font-semibold">
              {item.label}
            </p>

            <h2 className="text-lg font-bold text-gray-800 mt-2">
              {item.value}
            </h2>
          </div>

          <div
            className={`
              w-9 h-9 rounded-xl
              bg-gradient-to-br ${item.color}
              flex items-center justify-center
              text-white shadow-sm
            `}
          >
            <Icon size={16} />
          </div>

        </div>
      </div>
    );
  })}

</div>
      {/* CHART + CALENDAR */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-6">

        {/* CHART */}
        <div className="xl:col-span-2 bg-white rounded-3xl border border-gray-100 shadow-sm p-5">

          {/* HEADER */}
          <div className="flex items-center justify-between mb-5">

            <div>
              <h3 className="font-semibold text-gray-800">
                Budget vs Revenue Trend
              </h3>

              <p className="text-xs text-gray-400 mt-1">
                Daily marketing performance
              </p>
            </div>

            <div className="px-3 py-1.5 rounded-xl bg-indigo-50 text-indigo-600 text-xs font-semibold">
              Revenue Growth +
              {achievement.toFixed(1)}%
            </div>

          </div>

          {/* AREA */}
          <ResponsiveContainer
            width="100%"
            height={260}
          >
            <AreaChart data={trendData}>

              <defs>

                <linearGradient
                  id="revenue"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor="#6366f1"
                    stopOpacity={0.4}
                  />

                  <stop
                    offset="95%"
                    stopColor="#6366f1"
                    stopOpacity={0}
                  />

                </linearGradient>

              </defs>

              <CartesianGrid
                stroke="#f1f5f9"
                strokeDasharray="3 3"
              />

              <XAxis dataKey="date" />

              <YAxis
                tickFormatter={(v) =>
                  `${(
                    v / 1000000
                  ).toFixed(0)}M`
                }
              />

              <Tooltip
                formatter={(v) =>
                  formatRupiah(v)
                }
              />

              <Area
                type="monotone"
                dataKey="revenue"
                stroke="#6366f1"
                fill="url(#revenue)"
                strokeWidth={3}
              />

            </AreaChart>
          </ResponsiveContainer>

          {/* PIE GRID */}
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 mt-5">

            <PieCard
              title="Join Promo"
              value={
                categoryData.promo
                  ?.total || 0
              }
              percent={
                categoryData.promo
                  ?.percent || 0
              }
              color="#6366f1"
              icon={Megaphone}
              data={[
                {
                  name: "Done",
                  value:
                    categoryData.promo
                      ?.done || 0,
                },
                {
                  name: "Pending",
                  value:
                    categoryData.promo
                      ?.pending || 0,
                },
              ]}
            />

            <PieCard
              title="Join Event"
              value={
                categoryData.event
                  ?.total || 0
              }
              percent={
                categoryData.event
                  ?.percent || 0
              }
              color="#22c55e"
              icon={Calendar}
              data={[
                {
                  name: "Done",
                  value:
                    categoryData.event
                      ?.done || 0,
                },
                {
                  name: "Pending",
                  value:
                    categoryData.event
                      ?.pending || 0,
                },
              ]}
            />

            <PieCard
              title="Event Store"
              value={
                categoryData.store
                  ?.total || 0
              }
              percent={
                categoryData.store
                  ?.percent || 0
              }
              color="#f59e0b"
              icon={Target}
              data={[
                {
                  name: "Done",
                  value:
                    categoryData.store
                      ?.done || 0,
                },
                {
                  name: "Pending",
                  value:
                    categoryData.store
                      ?.pending || 0,
                },
              ]}
            />

            <PieCard
              title="Popup"
              value={
                categoryData.popup
                  ?.total || 0
              }
              percent={
                categoryData.popup
                  ?.percent || 0
              }
              color="#ef4444"
              icon={Plus}
              data={[
                {
                  name: "Done",
                  value:
                    categoryData.popup
                      ?.done || 0,
                },
                {
                  name: "Pending",
                  value:
                    categoryData.popup
                      ?.pending || 0,
                },
              ]}
            />

          </div>
        </div>

        {/* MINI CALENDAR */}
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-5">

          {/* HEADER */}
          <div className="flex items-center justify-between mb-5">

            <div>
              <h3 className="font-semibold text-gray-800">
                Marketing Calendar
              </h3>

              <p className="text-xs text-gray-400 mt-1">
                Campaign schedule
              </p>
            </div>

            <div className="flex items-center gap-1">

              <button
                onClick={prevMonth}
                className="w-8 h-8 rounded-xl hover:bg-gray-100 flex items-center justify-center transition"
              >
                <ChevronLeft size={16} />
              </button>

              <button
                onClick={nextMonth}
                className="w-8 h-8 rounded-xl hover:bg-gray-100 flex items-center justify-center transition"
              >
                <ChevronRight size={16} />
              </button>

            </div>

          </div>

          {/* MONTH */}
          <div className="text-center mb-4">

            <h4 className="font-bold text-gray-800">
              {monthNames[month]}{" "}
              {year}
            </h4>

          </div>

          {/* DAYS */}
          <div className="grid grid-cols-7 gap-1 mb-2">

            {days.map((day) => (
              <div
                key={day}
                className="text-center text-[10px] uppercase font-semibold text-gray-400 py-1"
              >
                {day}
              </div>
            ))}

          </div>

          {/* GRID */}
          <div className="grid grid-cols-7 gap-1">

  {calendarDays.map((day) => {
  if (!day) {
    return <div key={Math.random()} />;
  }

  const currentDate = new Date(year, month, day);
  const activeEvents = getActiveEventsOnDate(currentDate);

  const isToday =
    day === today.getDate() &&
    month === today.getMonth() &&
    year === today.getFullYear();

  const greenStyle = getGreenIntensity(activeEvents.length);

  // Cari apakah ada event di hari ini yang memiliki dokumentasi foto/aktivitas
  const eventWithPhoto = activeEvents.find(
    (ev) => (ev.foto_aktivitas && ev.foto_aktivitas.length > 0) || ev.nama_file || ev.foto
  );

  // Ambil nama file foto pertama jika tersedia
  const thumbnailFile = eventWithPhoto
    ? eventWithPhoto.nama_file || (eventWithPhoto.foto_aktivitas && eventWithPhoto.foto_aktivitas[0]?.nama_file) || eventWithPhoto.foto
    : null;

  // Hitung total foto
  const totalPhotosCount = eventWithPhoto?.foto_aktivitas?.length || (thumbnailFile ? 1 : 0);

  return (
    <div
      key={day}
      onClick={() => handleDateClick(day, activeEvents)}
      className={`
        aspect-square rounded-2xl border p-1.5 relative transition-all duration-300 cursor-pointer select-none group/day overflow-hidden
        ${
          isToday
            ? "border-indigo-400 bg-indigo-50/70 shadow-sm scale-[1.02]"
            : activeEvents.length > 0
              ? `${greenStyle} hover:border-green-400`
              : "border-gray-100 bg-gray-50/50 hover:bg-white hover:border-gray-300"
        }
        hover:shadow-md hover:-translate-y-0.5
      `}
    >
      {/* DAY NUMBER & DOT INDICATOR */}
      <div className="flex justify-between items-start relative z-10">
        <span
          className={`text-[11px] font-bold ${
            isToday ? "text-indigo-600" : "text-gray-700"
          }`}
        >
          {day}
        </span>

        {activeEvents.length > 0 && (
          <div className="w-1.5 h-1.5 rounded-full bg-green-600 mt-1 animate-pulse" />
        )}
      </div>

      {/* EVENTS TEXT */}
      <div className="mt-0.5 space-y-0.5 relative z-10 max-w-[75%]">
        {activeEvents.slice(0, 1).map((event, i) => (
          <div
            key={i}
            className="text-[9px] rounded-lg px-1 py-0.5 truncate font-bold bg-white/80 text-gray-800 shadow-sm border border-black/5"
          >
            {event.nama_event}
          </div>
        ))}
      </div>

      {/* ========================================================= */}
      {/* GELEMBUNG FOTO: SQUARE DENGAN RADIUS + ACTION KLIK        */}
      {/* ========================================================= */}
     {/* ========================================================= */}
{/* GELEMBUNG FOTO: SQUARE DENGAN RADIUS + MODAL VIEW ONLY     */}
{/* ========================================================= */}
{thumbnailFile && (
  <div 
    className="absolute bottom-1 right-1 z-30 pointer-events-auto"
    onClick={(e) => {
      e.stopPropagation(); // Mencegah klik kalender induk
      
      setViewGalleryEvent(eventWithPhoto);
      fetchGalleryAktivitas(eventWithPhoto.id_pengajuan); // Menggunakan fungsi fetch yang sudah kakak punya
      
      setShowViewGalleryModal(true); // Buka modal khusus view
    }}
  >
    {/* Efek Wave */}
    <div className="absolute inset-0 rounded-lg bg-purple-400/40 animate-ping opacity-75" style={{ animationDuration: '2s' }} />
    
    {/* Wadah Utama */}
    <div 
      className="relative w-7 h-7 rounded-lg p-[1.5px] bg-white shadow-lg border border-purple-200 overflow-hidden flex items-center justify-center bg-gradient-to-tr from-purple-500 to-indigo-500 transition-all duration-300 hover:scale-125 hover:rotate-3 active:scale-95"
      style={{ 
        animation: 'motionFloat 3s ease-in-out infinite',
        animationDelay: `${(day % 4) * 0.4}s` 
      }}
      title="Klik untuk melihat dokumentasi aktivitas"
    >
      <img 
        src={`/api/uploads/aktivitas/${thumbnailFile}`} 
        alt="Aktivitas" 
        className="w-full h-full object-cover rounded-[5px]"
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
      <span className="hidden text-[10px] text-white">📸</span>
    </div>
    
    {/* Badge +Count */}
    {totalPhotosCount > 1 && (
      <span className="absolute -top-1 -right-1.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-[7px] font-black px-1 min-w-[14px] h-3.5 rounded-md flex items-center justify-center border border-white shadow-sm animate-bounce">
        +{totalPhotosCount - 1}
      </span>
    )}
  </div>
)}
    </div>
  );
})}

          </div>

          <button
  onClick={() => {
  setForm({
    ...form,
    id_pengajuan: generateIdPengajuan(),
  });
  setShowAddEvent(true);
}}
  className="
    mt-5 w-full
    bg-indigo-600 hover:bg-indigo-700
    text-white rounded-2xl
    py-3 text-sm font-medium
    flex items-center justify-center gap-2
    transition
  "
>
  <Plus size={16} />
  Add Event
</button>

        </div>
      </div>

      {/* PLANNING TABLE */}
{/* PLANNING TABLE */}
{/* PLANNING TABLE */}
  <div className="mt-6 bg-white rounded-3xl border border-gray-100 shadow-sm p-5">

    <div className="flex items-center justify-between mb-4">
      <div>
        <h3 className="font-semibold text-gray-800">
          Marketing Planning List
        </h3>
        <p className="text-xs text-gray-400 mt-1">
          Tabel semua campaign dalam periode terpilih
        </p>
      </div>
    </div>

    {/* TABLE WRAPPER - Ditambahkan pb-20 agar dropdown paling bawah aman tidak terpotong */}
    <div className="overflow-x-auto pb-20">

      {/* Ditambahkan min-w-[1000px] agar layout tabel di mobile tetap rapi dan tidak gepeng */}
      <table className="w-full text-sm min-w-[1000px]">

        {/* HEADER */}
        <thead>
          <tr className="text-left text-xs text-gray-400 border-b">
            <th className="py-3">Event</th>
            <th>Periode</th>
            <th>Kategori</th>
            <th>Status</th>
            <th>Teknis Promo</th>
            <th>Budget</th>
            <th>Revenue</th>
            <th>Target</th>
            <th>Achievement</th>
            {/* Lebar th aksi diperjelas & text center */}
            <th className="w-20 text-center">Aksi</th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody>

          {marketingCalendar.length === 0 ? (
            <tr>
              <td colSpan="10" className="py-6 text-center text-gray-400">
                Tidak ada data planning
              </td>
            </tr>
          ) : (
            marketingCalendar.map((item, i) => {

              const getStatus = (item) => {
                const today = new Date();
                const start = new Date(item.start_date);
                const end = new Date(item.end_date);

                if (item.status === 2 && today >= start && today <= end) {
                  return { label: "ONGOING", color: "bg-green-100 text-green-700" };
                }

                if (item.status === 2 && today >= end) {
                  return { label: "ENDED", color: "bg-red-100 text-red-700" };
                }

                switch (item.status) {
                  case 0:
                    return { label: "PLANNING", color: "bg-gray-100 text-gray-600" };
                  case 1:
                    return { label: "UPCOMING", color: "bg-yellow-100 text-yellow-700" };
                  case 2:
                    return { label: "APPROVED", color: "bg-blue-100 text-blue-700" };
                  default:
                    return { label: "UNKNOWN", color: "bg-red-100 text-red-700" };
                }
              };

              const status = getStatus(item);
              const budget = Number(item.budget || 0);
              const revenue = Number(item.revenue || 0);
              const target = Number(item.target || budget * 1.2);
              const achievement = target > 0 ? (revenue / target) * 100 : 0;

              // Kondisi pengecekan status ONGOING atau ENDED
              const isOngoingOrEnded = status.label === "ONGOING" || status.label === "ENDED";

              return (
                <tr
                  key={i}
                  onClick={() => {
                    setSelectedDate(new Date(item.start_date));
                    setSelectedEvents([item]);
                    setShowModal(true);
                  }}
                  className="border-b last:border-none hover:bg-gray-50 cursor-pointer transition"
                >

                  {/* EVENT */}
                  <td className="py-3 font-semibold text-gray-800">
                    {item.nama_event}
                  </td>

                  {/* PERIODE */}
                  <td className="text-gray-500 text-xs">
                    {formatDate(item.start_date)} → {formatDate(item.end_date)}
                  </td>

                  {/* KATEGORI */}
                  <td className="text-gray-600">
                    {item.kategori}
                  </td>

                  {/* STATUS */}
                  <td>
                    <span className={`px-2 py-1 text-xs rounded-lg font-medium ${status.color}`}>
                      {status.label}
                    </span>
                  </td>

                  {/* TEKNIS PROMO */}
                  <td>
                    {item.teknis_promo === "SCAN_QR" || item.teknis_promo === "FLYERING" || item.teknis_promo === "FLYER_QR" ? (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setQrUrl(getQrLink(item.id_pengajuan));
                          setShowQR(true);
                        }}
                        className="px-2 py-1 text-xs rounded-lg bg-indigo-100 text-indigo-700 font-medium hover:bg-indigo-200"
                      >
                        {item.teknis_promo}
                      </button>
                    ) : (
                      <span className="text-gray-600 text-xs">
                        {item.teknis_promo}
                      </span>
                    )}
                  </td>

                  {/* BUDGET */}
                  <td className="text-gray-700">
                    {formatRupiah(budget)}
                  </td>

                  {/* REVENUE */}
                  <td className="text-green-600 font-medium">
                    {formatRupiah(revenue)}
                  </td>

                  {/* TARGET */}
                  <td className="text-gray-700">
                    {formatRupiah(target)}
                  </td>

                  {/* ACHIEVEMENT */}
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="w-20 h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-indigo-500"
                          style={{
                            width: `${Math.min(achievement, 100)}%`
                          }}
                        />
                      </div>
                      <span className="text-xs text-indigo-600 font-semibold">
                        {achievement.toFixed(1)}%
                      </span>
                    </div>
                  </td>

                  {/* AKSI */}
                  <td className="text-center relative py-3" onClick={(e) => e.stopPropagation()}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenAction(openAction === i ? null : i);
                      }}
                      className="p-2 rounded-lg hover:bg-gray-100 transition inline-flex items-center justify-center"
                    >
                      <MoreVertical size={18} />
                    </button>

                    {openAction === i && (
                      <div
                        className="
                          absolute right-4 top-full z-30
                          w-52 bg-white border border-gray-200
                          rounded-xl shadow-xl
                          overflow-hidden mt-1
                        "
                      >
                        {/* 🌟 TOMBOL TAMBAHAN KHUSUS ONGOING / ENDED */}
                        {isOngoingOrEnded && (
                          <>
                           <button
  onClick={(e) => {
    e.stopPropagation();
    setOpenAction(null); // Tutup dropdown menu aksi
    setSelectedBudgetEvent(item); // Simpan item data baris tabel
    setShowBudgetModal(true); // Buka modal
    fetchBudgetHistory(item.id_pengajuan); // Ambil data history dari backend
  }}
  className="w-full px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-gray-50 text-gray-700 text-left border-b border-gray-50"
>
  <span className="w-4 h-4 rounded bg-amber-100 flex items-center justify-center text-amber-600 text-[10px] font-bold">Rp</span>
  Penggunaan Budget
</button>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                // Integrasikan fungsi/routing Pengambilan Produk di sini
                                console.log("Pengambilan Produk:", item.id_pengajuan);
                              }}
                              className="w-full px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-gray-50 text-gray-700 text-left border-b border-gray-50"
                            >
                              <span className="w-4 h-4 rounded bg-blue-100 flex items-center justify-center text-blue-600 text-[10px] font-bold">P</span>
                              Pengambilan Produk
                            </button>

                           <button
  onClick={(e) => {
    e.stopPropagation();
    setOpenAction(null); // Tutup dropdown menu aksi jika terbuka
    setSelectedGalleryEvent(item); // 'item' disesuaikan dengan objek baris data event Anda
    setShowGalleryModal(true);
    fetchGalleryAktivitas(item.id_pengajuan);
  }}
  className="w-full px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-gray-50 text-gray-700 text-left border-b border-gray-100"
>
  <span className="w-4 h-4 rounded bg-purple-100 flex items-center justify-center text-purple-600 text-[10px] font-bold">G</span>
  Galeri Aktivitas
</button>
                          </>
                        )}

                        {/* DOWNLOAD LPH */}
                        {Number(item.revenue || 0) > 0 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(
                                `/api/marketing/marketing-plan/download-lph/${item.id_pengajuan}`,
                                "_blank"
                              );
                            }}
                            className="
                              w-full px-4 py-2.5 text-sm
                              flex items-center gap-2
                              hover:bg-gray-50 text-gray-700 text-left
                            "
                          >
                            <Download size={16} className="text-gray-400" />
                            Download LPH
                          </button>
                        )}

                        {/* DELETE */}
                        {item.status === 0 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteTarget(item);
                              setShowDeleteModal(true);
                            }}
                            className="w-full px-4 py-2.5 text-sm flex items-center gap-2 hover:bg-red-50 text-red-600 text-left"
                          >
                            <Trash2 size={16} />
                            Hapus Event
                          </button>
                        )}
                        
                        {/* KONDISI JIKA TIDAK ADA AKSI SAMA SEKALI */}
                        {!isOngoingOrEnded && item.status !== 0 && Number(item.revenue || 0) <= 0 && (
                          <div className="px-4 py-3 text-xs text-gray-400 text-left">
                            Tidak ada aksi
                          </div>
                        )}
                      </div>
                    )}
                  </td>

                </tr>
              );
            })
          )}

        </tbody>
      </table>
    </div>
  </div>

{showDeleteModal && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
    <div className="bg-white w-[400px] rounded-2xl p-6 shadow-xl">

      <h2 className="text-lg font-bold mb-2 text-gray-800">
        Konfirmasi Hapus
      </h2>

      <p className="text-sm text-gray-500 mb-4">
        Yakin ingin menghapus event{" "}
        <span className="font-semibold text-gray-700">
          {deleteTarget?.nama_event}
        </span>
        ?
      </p>

      <div className="flex justify-end gap-2">

        <button
          onClick={() => {
            setShowDeleteModal(false);
            setDeleteTarget(null);
          }}
          className="px-4 py-2 text-sm bg-gray-200 rounded-xl hover:bg-gray-300"
          disabled={submitLoading}
        >
          Batal
        </button>

        <button
          onClick={async () => {
            try {
              setSubmitLoading(true);

              await axios.delete(
                `/api/marketing/marketing-plan/${deleteTarget.id_pengajuan}`,
                {
                  data: { kategori: deleteTarget.kategori },
                }
              );

              setShowDeleteModal(false);
              setDeleteTarget(null);

              getMarketingPlan();
            } catch (err) {
              console.error("DELETE ERROR:", err);
              alert("Gagal menghapus data");
            } finally {
              setSubmitLoading(false);
            }
          }}
          disabled={submitLoading}
          className={`
            px-4 py-2 text-sm text-white rounded-xl transition
            flex items-center justify-center gap-2
            ${
              submitLoading
                ? "bg-red-300 cursor-not-allowed"
                : "bg-red-600 hover:bg-red-700"
            }
          `}
        >
          {submitLoading ? (
            <>
              <svg
                className="animate-spin h-4 w-4"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  className="opacity-25"
                />
                <path
                  fill="currentColor"
                  className="opacity-75"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
              Menghapus...
            </>
          ) : (
            "Delete"
          )}
        </button>

      </div>
    </div>
  </div>
)}


{showQR && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
    
    <div className="bg-white w-[420px] rounded-3xl p-6 shadow-xl text-center">

      <h3 className="font-bold text-gray-800 mb-2">
        QR Event
      </h3>

      <p className="text-xs text-gray-500 mb-4 break-all">
        {qrUrl}
      </p>

      {/* QR IMAGE */}
      <img
        src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(qrUrl)}`}
        alt="QR Code"
        className="mx-auto rounded-xl border"
      />

      {/* ACTION */}
      <div className="flex gap-2 mt-5">

        <a
          href={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(qrUrl)}`}
          download="qr-event.png"
          className="flex-1 bg-indigo-600 text-white py-2 rounded-xl text-sm font-medium"
        >
          Download QR
        </a>

        <button
          onClick={() => setShowQR(false)}
          className="flex-1 bg-gray-100 py-2 rounded-xl text-sm"
        >
          Close
        </button>

      </div>

    </div>
  </div>
)}

{showAddEvent && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
    <div className="bg-white w-[800px] max-h-[95vh] overflow-auto rounded-3xl p-6 shadow-xl">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-bold text-lg">
          Form Pengajuan Event Marketing
        </h2>
        <button onClick={() => setShowAddEvent(false)}>
          ✕
        </button>
      </div>

      {/* VALIDATION LOGIC */}
      {(() => {
        const isFlyering = form.teknis_promo === "FLYERING";

        const isFormValid =
          form.id_pengajuan &&
          form.nama_event &&
          form.start_date &&
          form.end_date &&
          form.kategori &&
          form.pic &&
          form.teknis_promo &&
          form.budget &&
          form.netto &&
          form.goals &&
form.tujuan_pencairan &&
form.nama_penerima_tf &&
form.bank_penerima &&
form.nomor_rekening_penerima &&
          (!isFlyering || form.lokasi_penyebaran);

        return (
          <>
            <div className="grid grid-cols-2 gap-4 text-sm">

              {/* ID */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  ID Pengajuan
                </label>
                <input
                  value={form.id_pengajuan}
                  disabled
                  className="border p-2 rounded-xl bg-gray-100 text-gray-500"
                />
                <p className="text-[10px] text-gray-400">
                  Auto generated system ID
                </p>
              </div>

              {/* KATEGORI */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Kategori *
                </label>
                <select
                  className="border p-2 rounded-xl"
                  value={form.kategori}
                  onChange={(e) =>
                    setForm({ ...form, kategori: e.target.value })
                  }
                >
                  <option value="JOIN PROMO">JOIN PROMO</option>
                  <option value="JOIN EVENT">JOIN EVENT</option>
                  <option value="EVENT AT STORE">EVENT AT STORE</option>
                </select>
              </div>

              {/* NAMA EVENT */}
              <div className="flex flex-col gap-1 col-span-2">
                <label className="text-xs font-semibold text-gray-600">
                  Nama Event *
                </label>
                <input
                  className={`border p-2 rounded-xl ${
                    !form.nama_event ? "border-red-300" : ""
                  }`}
                  value={form.nama_event}
                  onChange={(e) =>
                    setForm({ ...form, nama_event: e.target.value })
                  }
                  placeholder="Contoh: Weekend Promo Lebaran"
                />
              </div>

              {/* DATE */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Start Date *
                </label>
                <input
                  type="date"
                  className={`border p-2 rounded-xl ${
                    !form.start_date ? "border-red-300" : ""
                  }`}
                  value={form.start_date}
                  onChange={(e) =>
                    setForm({ ...form, start_date: e.target.value })
                  }
                />
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  End Date *
                </label>
                <input
                  type="date"
                  className={`border p-2 rounded-xl ${
                    !form.end_date ? "border-red-300" : ""
                  }`}
                  value={form.end_date}
                  onChange={(e) =>
                    setForm({ ...form, end_date: e.target.value })
                  }
                />
              </div>

              {/* PIC */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  PIC
                </label>
                <select
                  className="border p-2 rounded-xl"
                  value={form.pic}
                  onChange={(e) =>
                    setForm({ ...form, pic: e.target.value })
                  }
                >
                  <option>SALES</option>
                </select>
              </div>

              {/* TEKNIS PROMO */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Teknis Promo *
                </label>
                <select
                  className="border p-2 rounded-xl"
                  value={form.teknis_promo}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      teknis_promo: e.target.value,
                    })
                  }
                >
                  <option value="SCAN_QR">SCAN_QR</option>
                  <option value="FLYER_QR">FLYER QR</option>
                  <option value="REGULER_POS">REGULER POS</option>
                </select>
              </div>

              {/* BUDGET */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Budget *
                </label>
                <input
                  type="number"
                  className={`border p-2 rounded-xl ${
                    !form.budget ? "border-red-300" : ""
                  }`}
                  value={form.budget}
                  onChange={(e) =>
                    setForm({ ...form, budget: e.target.value })
                  }
                />
              </div>

              {/* TARGET */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Netto / Target *
                </label>
                <input
                  type="number"
                  className={`border p-2 rounded-xl ${
                    !form.netto ? "border-red-300" : ""
                  }`}
                  value={form.netto}
                  onChange={(e) =>
                    setForm({ ...form, netto: e.target.value })
                  }
                />
              </div>

              {/* GOALS */}
<div className="flex flex-col gap-1 col-span-2">
  <label className="text-xs font-semibold text-gray-600">
    Goals *
  </label>
  <input
    className={`border p-2 rounded-xl ${
      !form.goals ? "border-red-300" : ""
    }`}
    value={form.goals}
    onChange={(e) =>
      setForm({ ...form, goals: e.target.value })
    }
    placeholder="Contoh: meningkatkan traffic / sales / awareness"
  />
</div>

{/* TUJUAN PENCAIRAN */}
<div className="flex flex-col gap-1 col-span-2">
  <label className="text-xs font-semibold text-gray-600">
    Tujuan Pencairan *
  </label>
  <input
    className={`border p-2 rounded-xl ${
      !form.tujuan_pencairan ? "border-red-300" : ""
    }`}
    value={form.tujuan_pencairan}
    onChange={(e) =>
      setForm({ ...form, tujuan_pencairan: e.target.value })
    }
    placeholder="Contoh: reimbursement / operational / event cost"
  />
</div>

{/* NAMA PENERIMA TF */}
<div className="flex flex-col gap-1">
  <label className="text-xs font-semibold text-gray-600">
    Nama Penerima Transfer *
  </label>
  <input
    className={`border p-2 rounded-xl ${
      !form.nama_penerima_tf ? "border-red-300" : ""
    }`}
    value={form.nama_penerima_tf}
    onChange={(e) =>
      setForm({ ...form, nama_penerima_tf: e.target.value })
    }
    placeholder="Nama sesuai rekening"
  />
</div>

{/* BANK PENERIMA */}
<div className="flex flex-col gap-1">
  <label className="text-xs font-semibold text-gray-600">
    Bank Penerima *
  </label>
  <input
    className={`border p-2 rounded-xl ${
      !form.bank_penerima ? "border-red-300" : ""
    }`}
    value={form.bank_penerima}
    onChange={(e) =>
      setForm({ ...form, bank_penerima: e.target.value })
    }
    placeholder="Contoh: BCA / BRI / Mandiri"
  />
</div>

{/* NOMOR REKENING */}
<div className="flex flex-col gap-1 col-span-2">
  <label className="text-xs font-semibold text-gray-600">
    Nomor Rekening Penerima *
  </label>
  <input
    type="number"
    className={`border p-2 rounded-xl ${
      !form.nomor_rekening_penerima ? "border-red-300" : ""
    }`}
    value={form.nomor_rekening_penerima}
    onChange={(e) =>
      setForm({
        ...form,
        nomor_rekening_penerima: e.target.value,
      })
    }
    placeholder="Nomor rekening"
  />
</div>



              {/* FLYERING SECTION */}
              <div className="col-span-2 mt-2">
                <div className="text-xs font-bold text-gray-500 uppercase">
                  📍 Field Khusus FLYERING
                </div>
              </div>

              {/* LOKASI */}
              <div className="flex flex-col gap-1 col-span-2">
                <label className="text-xs font-semibold text-gray-600">
                  Lokasi Penyebaran
                  {isFlyering && (
                    <span className="text-red-500"> *</span>
                  )}
                </label>

                <input
                  className={`border p-2 rounded-xl ${
                    isFlyering && !form.lokasi_penyebaran
                      ? "border-red-400"
                      : ""
                  }`}
                  value={form.lokasi_penyebaran}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      lokasi_penyebaran: e.target.value,
                    })
                  }
                />
              </div>

              {/* TRAFFIC */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Target Traffic
                </label>
                <input
                  type="number"
                  className="border p-2 rounded-xl"
                  value={form.target_traffic}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      target_traffic: e.target.value,
                    })
                  }
                />
              </div>

              {/* HARGA */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-gray-600">
                  Harga Satuan
                </label>
                <input
                  type="number"
                  className="border p-2 rounded-xl"
                  value={form.harga_satuan}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      harga_satuan: e.target.value,
                    })
                  }
                />
              </div>

            </div>

            {/* BUTTON */}
            <div className="flex flex-col gap-2 mt-5">

              {!isFormValid && !submitLoading && (
                <p className="text-xs text-red-500">
                  ⚠ Lengkapi semua field wajib sebelum submit
                </p>
              )}

              <button
                onClick={handleSubmit}
                disabled={!isFormValid || submitLoading}
                className={`
                  px-4 py-2 rounded-xl text-white font-medium
                  flex items-center justify-center gap-2
                  transition w-full
                  ${
                    !isFormValid || submitLoading
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-indigo-600 hover:bg-indigo-700"
                  }
                `}
              >
                {submitLoading ? (
                  <>
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                    Saving...
                  </>
                ) : !isFormValid ? (
                  "Form Belum Lengkap"
                ) : (
                  "Submit Event"
                )}
              </button>
            </div>
          </>
        );
      })()}
    </div>
  </div>
)}

{showModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">

    <div className="bg-white w-[540px] rounded-3xl p-6 shadow-xl">

      {/* HEADER */}
    <div className="flex items-center justify-between mb-2">
  <div>
    <h3 className="font-bold text-gray-800">
      Detail Marketing Plan
    </h3>
    <h4 className="text-sm text-gray-600 font-medium">
      {selectedEvents[0]?.id_pengajuan}
    </h4>
  </div>

  <button
    onClick={() => setShowModal(false)}
    className="text-gray-400 hover:text-gray-600 text-lg leading-none"
  >
    ✕
  </button>
</div>

      <p className="text-sm text-gray-500 mb-4">
        {selectedDate?.toDateString()}
      </p>

      {/* SUMMARY DASHBOARD */}
      {selectedEvents.length > 0 && (() => {

        const totalBudget = selectedEvents.reduce(
          (a, b) => a + Number(b.budget || 0),
          0
        );

        const totalRevenue = selectedEvents.reduce(
          (a, b) => a + Number(b.revenue || 0),
          0
        );

         const totalRevenueAcquisition = selectedEvents.reduce(
          (a, b) => a + Number(b.acquisition_revenue || 0),
          0
        );

          const totalTarget = selectedEvents.reduce(
          (a, b) => a + Number(b.target || 0),
          0
        );


        const achievement =
          totalTarget > 0
            ? (totalRevenue / totalTarget) * 100
            : 0;

        return (
          <div className="grid grid-cols-2 gap-2 mb-4 text-sm">

            <div className="p-3 bg-indigo-50 rounded-2xl">
              <p className="text-xs text-gray-500">Budget</p>
              <p className="font-bold">{formatRupiah(totalBudget)}</p>
            </div>

           

            <div className="p-3 bg-yellow-50 rounded-2xl">
              <p className="text-xs text-gray-500">Target</p>
              <p className="font-bold">{formatRupiah(totalTarget)}</p>
            </div>

             <div className="p-3 bg-green-50 rounded-2xl">
              <p className="text-xs text-gray-500">Revenue</p>
              <p className="font-bold text-green-600">
                {formatRupiah(totalRevenue)}
              </p>
            </div>

            

            <div className="p-3 bg-purple-50 rounded-2xl">
              <p className="text-xs text-gray-500">Achievement</p>
              <p className="font-bold text-purple-600">
                {achievement.toFixed(1)}%
              </p>
            </div>

          </div>
        );
      })()}

      {/* LIST EVENTS */}
      {selectedEvents.length === 0 ? (
        <p className="text-sm text-gray-400">
          Tidak ada event
        </p>
      ) : (
        <div className="space-y-4 max-h-[360px] overflow-auto">

          {selectedEvents.map((event, i) => {

            const budget = Number(event.budget || 0);
            const revenue = Number(event.revenue || 0);

            const target =
              Number(event.target || 0) || budget * 1.2;

            const achievement =
              target > 0 ? (revenue / target) * 100 : 0;

            return (
              <div key={i} className="p-4 rounded-2xl border bg-gray-50">

                <div className="font-semibold text-gray-800">
                  {event.nama_event}
                </div>

                <div className="text-xs text-gray-500 mb-3">
                  {event.status} • {event.kategori}
                </div>

                {/* GRID */}
                <div className="grid grid-cols-2 gap-2 text-sm">

                  <div>
                    <p className="text-xs text-gray-400">Budget</p>
                    <p className="font-semibold">
                      {formatRupiah(budget)}
                    </p>
                  </div>

                  

                  <div>
                    <p className="text-xs text-gray-400">Target</p>
                    <p className="font-semibold">
                      {formatRupiah(target)}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-400">Revenue</p>
                    <p className="font-semibold text-green-600">
                      {formatRupiah(revenue)}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-400">Achievement</p>
                    <p className="font-semibold text-indigo-600">
                      {achievement.toFixed(1)}%
                    </p>
                  </div>

                </div>

                {/* PROGRESS */}
                <div className="mt-3 h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-indigo-500"
                    style={{
                      width: `${Math.min(achievement, 100)}%`
                    }}
                  />
                </div>

              </div>
            );
          })}
        </div>
      )}

    </div>
  </div>
)}

{/* MODAL GALERI AKTIVITAS EVENT */}
{/* MODAL GALERI AKTIVITAS EVENT */}
{/* MODAL GALERI AKTIVITAS EVENT */}
{showGalleryModal && selectedGalleryEvent && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    {/* Backdrop dengan blur sinematik */}
    <div 
      className="absolute inset-0 bg-slate-900/60 backdrop-blur-md transition-all duration-300 animate-in fade-in" 
      onClick={() => { setShowGalleryModal(false); setGalleryPreview(null); }} 
    />

    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col relative z-10 animate-in fade-in zoom-in-95 duration-300 border border-slate-100">
      
      {/* Header Premium dengan Efek Glassmorphism */}
      <div className="p-6 border-b border-slate-100 flex items-center justify-between bg-gradient-to-r from-purple-50/50 via-indigo-50/30 to-white">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-2xl bg-gradient-to-tr from-purple-500 to-indigo-500 text-white shadow-md shadow-purple-200 animate-pulse">
            <Camera className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-lg font-extrabold text-slate-800 tracking-tight">
              Galeri Aktivitas Event
            </h3>
            <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-1.5">
              ID: <span className="font-mono bg-slate-100 px-1.5 py-0.5 rounded text-slate-600 font-medium">{selectedGalleryEvent.id_pengajuan}</span>
              • Event: <span className="font-bold text-purple-600 bg-purple-50 px-2 py-0.5 rounded-full">{selectedGalleryEvent.nama_event}</span>
            </p>
          </div>
        </div>
        <button 
          onClick={() => { setShowGalleryModal(false); setGalleryPreview(null); }} 
          className="p-2 rounded-xl bg-slate-50 text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 font-bold"
        >
          ✕
        </button>
      </div>

      {/* Body Content */}
      <div className="p-6 overflow-y-auto grid grid-cols-1 md:grid-cols-12 gap-8 bg-slate-50/30">
        
        {/* SISI KIRI: Form Upload Gambar (Sticky Animative) */}
        <div className="md:col-span-4 bg-white p-5 rounded-2xl border border-slate-100 shadow-sm h-fit space-y-5">
          <div>
            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-purple-500 animate-ping"></span>
              Upload Media Baru
            </h4>
          </div>

          <form onSubmit={handleGallerySubmit} className="space-y-4">
            {/* Box Drop/Click Gambar Interaktif */}
            <div className="relative border-2 border-dashed border-slate-200 hover:border-purple-400 rounded-2xl bg-slate-50/50 p-4 text-center cursor-pointer transition-all duration-300 h-48 flex flex-col items-center justify-center overflow-hidden group">
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleGalleryFileChange} 
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10" 
              />
              
              {galleryPreview === null ? (
                <div className="space-y-3 flex flex-col items-center group-hover:scale-105 transition-transform duration-300">
                  <div className="p-3 rounded-2xl bg-purple-50 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-all duration-300 shadow-sm">
                    <Camera className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-xs font-bold text-slate-700">Ambil / Pilih Gambar</p>
                    <p className="text-[10px] text-slate-400 mt-0.5">Format JPEG, PNG (Maks. 4MB)</p>
                  </div>
                </div>
              ) : (
                <div className="absolute inset-0 w-full h-full animate-in fade-in zoom-in-100 duration-300">
                  <img src={galleryPreview} alt="Preview Upload" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-black/30 backdrop-blur-[1px] opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                    <p className="text-white text-xs font-bold bg-black/50 px-3 py-1.5 rounded-xl backdrop-blur-md">Ganti Foto 🔄</p>
                  </div>
                </div>
              )}
            </div>

            {/* Batal Button */}
            {galleryPreview && (
              <button 
                type="button" 
                onClick={() => { setGalleryForm({...galleryForm, foto_file: null}); setGalleryPreview(null); }} 
                className="text-xs text-rose-500 font-semibold block mx-auto hover:text-rose-600 hover:underline transition-colors"
              >
                Batalkan Pilihan
              </button>
            )}

            {/* Keterangan Form */}
            <div className="space-y-1">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wider">Keterangan Foto</label>
              <textarea
                rows="3"
                placeholder="Tulis aktivitas di lapangan..."
                value={galleryForm.keterangan}
                onChange={(e) => setGalleryForm({ ...galleryForm, keterangan: e.target.value })}
                className="w-full px-3 py-2 text-xs border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 bg-slate-50/50 transition-all resize-none"
              />
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-xl text-xs font-bold transition-all duration-300 shadow-md shadow-purple-200 hover:shadow-lg hover:shadow-purple-300 active:scale-[0.98]"
            >
              Unggah Dokumentasi
            </button>
          </form>
        </div>

        {/* SISI KANAN: Grid Item Foto dengan Animasi Menarik */}
        <div className="md:col-span-8 flex flex-col space-y-4">
          <div className="flex items-center justify-between">
            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
              Koleksi Foto Terunggah ({galleryImages.length})
            </h4>
          </div>
          
          {isLoadingGallery ? (
            <div className="flex flex-col items-center justify-center py-32 space-y-3 bg-white rounded-2xl border border-slate-100">
              <div className="w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-xs font-medium text-slate-400">Sinkronisasi data galeri...</p>
            </div>
          ) : galleryImages.length === 0 ? (
            <div className="text-center py-28 border border-dashed border-slate-200 rounded-2xl text-slate-400 text-xs bg-white space-y-2">
              <div className="text-3xl animate-bounce">🖼️</div>
              <p className="font-medium text-slate-500">Belum ada dokumentasi foto.</p>
              <p className="text-[11px] text-slate-400">Gunakan panel kiri untuk mulai mengunggah aktivitas.</p>
            </div>
          ) : (
            /* Grid Image Container */
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 max-h-[420px] overflow-y-auto pr-1">
              {galleryImages.map((img, index) => (
                <div 
                  key={img.id} 
                  style={{ animationDelay: `${index * 50}ms` }}
                  onClick={() => setActiveLightboxImage(img)} // MEMBUKA LIGHTBOX PREVIEW SAAT DIKLIK
                  className="group relative rounded-2xl overflow-hidden border border-slate-100 bg-slate-900 aspect-square shadow-sm hover:shadow-xl transition-all duration-300 animate-in fade-in slide-in-from-bottom-4 cursor-zoom-in"
                >
                  {/* Foto Utama */}
                  <img 
                    src={`/api/uploads/aktivitas/${img.nama_file}`} 
                    alt={img.keterangan} 
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 group-hover:rotate-1 transition-transform duration-500 opacity-95 group-hover:opacity-80" 
                  />
                  
                  {/* Glassmorphism Badge Tanggal */}
                  <div className="absolute top-2 left-2 px-2 py-1 rounded-lg bg-white/20 backdrop-blur-md border border-white/20 text-[9px] text-white font-bold tracking-wider shadow-sm opacity-100 group-hover:opacity-0 transition-opacity duration-200">
                    {new Date(img.created_at).toLocaleDateString("id-ID", { day: 'numeric', month: 'short' })}
                  </div>

                  {/* Overlay Gradasi & Keterangan */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 p-3.5 flex flex-col justify-end transform translate-y-2 group-hover:translate-y-0">
                    <p className="text-[11px] text-white font-semibold leading-relaxed line-clamp-3">
                      {img.keterangan || 'Tanpa deskripsi aktivitas'}
                    </p>
                    <div className="mt-2 pt-2 border-t border-white/10 flex items-center justify-between text-[9px] text-purple-300 font-medium">
                      <span>Toko: {img.kode_toko || 'ALL'}</span>
                      <span className="bg-purple-500/30 px-1.5 py-0.5 rounded text-white font-semibold">Klik Detail 🔍</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>

    {/* ========================================================= */}
    {/* LIGHTBOX ULTRA PREMIUM LAYER PREVIEW (NESTED MODAL)       */}
    {/* ========================================================= */}
    {activeLightboxImage && (
      <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center p-4 md:p-8 animate-in fade-in duration-200">
        {/* Backdrop super gelap dengan efek blur tinggi */}
        <div 
          className="absolute inset-0 bg-slate-950/90 backdrop-blur-xl"
          onClick={() => setActiveLightboxImage(null)} // Klik luar untuk close
        />
        
        {/* Tombol Tutup Melayang Atas */}
        <button 
          onClick={() => setActiveLightboxImage(null)}
          className="absolute top-6 right-6 z-10 w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white text-lg font-bold border border-white/10 transition-all duration-200 backdrop-blur-md active:scale-90"
        >
          ✕
        </button>

        {/* Box Konten Preview */}
        <div className="relative max-w-4xl w-full max-h-[75vh] flex items-center justify-center animate-in zoom-in-95 duration-300 select-none">
          <img 
            src={`/api/uploads/aktivitas/${activeLightboxImage.nama_file}`} 
            alt="Preview Detail" 
            className="max-w-full max-h-[75vh] rounded-2xl object-contain shadow-2xl border border-white/5"
          />
        </div>

        {/* Panel Informasi Keterangan Mengambang di Bawah Gambar */}
        <div className="relative z-10 mt-6 max-w-2xl w-full bg-white/10 backdrop-blur-md border border-white/10 rounded-2xl p-4 text-center shadow-xl animate-in slide-in-from-bottom-4 duration-300">
          <p className="text-white text-sm font-medium leading-relaxed">
            {activeLightboxImage.keterangan || "Tidak ada keterangan aktivitas lapangan yang disematkan."}
          </p>
          <div className="flex items-center justify-center gap-4 text-[11px] text-slate-300 mt-2.5 pt-2.5 border-t border-white/5 font-mono">
            <span>🏪 Toko: <span className="text-purple-300 font-bold">{activeLightboxImage.kode_toko || 'ALL'}</span></span>
            <span>•</span>
            <span>📅 Tanggal: <span className="text-purple-300 font-bold">{new Date(activeLightboxImage.created_at).toLocaleDateString("id-ID", { day: 'numeric', month: 'long', year: 'numeric' })}</span></span>
            <span>•</span>
            <span>⏰ Jam: <span className="text-purple-300 font-bold">{new Date(activeLightboxImage.created_at).toLocaleTimeString("id-ID", { hour: '2-digit', minute: '2-digit' })} WIB</span></span>
          </div>
        </div>
      </div>
    )}
  </div>
)}
{/* MODAL PENGGUNAAN BUDGET + UPLOAD BUKTI */}
{/* MODAL PENGGUNAAN BUDGET */}
{showBudgetModal && selectedBudgetEvent && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    
    {/* BACKDROP BLUR */}
    <div 
      className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      onClick={() => {
        setShowBudgetModal(false);
        setBuktiPreview(null);
      }}
    />

    {/* KONTEN MODAL */}
    <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col relative z-10">
      
      {/* HEADER */}
      <div className="p-6 border-b border-gray-100 flex items-center justify-between bg-gray-50/50">
        <div>
          <h3 className="text-lg font-bold text-gray-800">Penggunaan Budget</h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Event: <span className="font-semibold text-indigo-600">{selectedBudgetEvent.nama_event}</span>
          </p>
        </div>
        <button 
          onClick={() => {
            setShowBudgetModal(false);
            setBuktiPreview(null);
          }}
          className="p-2 rounded-xl hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      {/* BODY MODAL */}
      <div className="p-6 overflow-y-auto grid grid-cols-1 md:grid-cols-12 gap-6">
        
        {/* SISI KIRI: FORM INPUT & UPLOAD */}
        <div className="md:col-span-5 border-r border-gray-100 pr-0 md:pr-6">
          <h4 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-amber-500"></span> Input Biaya & Bukti
          </h4>
          
          <form onSubmit={handleBudgetSubmit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Nominal Biaya (Rp)</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-medium text-sm">Rp</span>
                <input 
                  type="number" 
                  required
                  placeholder="0"
                  value={budgetForm.biaya}
                  onChange={(e) => setBudgetForm({...budgetForm, biaya: e.target.value})}
                  className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Tipe Pembayaran</label>
              <select 
                value={budgetForm.tipe_pembayaran}
                onChange={(e) => setBudgetForm({...budgetForm, tipe_pembayaran: e.target.value})}
                className="w-full px-3 py-2 text-sm border border-gray-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
              >
                <option value="CASH">Cash</option>
                <option value="TRANSFER">Transfer</option>
                <option value="REIMBURSE">Reimburse</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Keterangan Penggunaan</label>
              <textarea 
                rows="2"
                required
                placeholder="Contoh: Pembelian perlengkapan banner..."
                value={budgetForm.keterangan}
                onChange={(e) => setBudgetForm({...budgetForm, keterangan: e.target.value})}
                className="w-full px-3 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 transition resize-none"
              />
            </div>

            {/* UPLOAD FILE BUKTI (NOTA) */}
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Upload Bukti Fisik (Nota/Kuitansi)</label>
              <div className="relative border-2 border-dashed border-gray-200 rounded-xl hover:border-indigo-400 transition bg-gray-50/50 p-3 text-center cursor-pointer">
                <input 
                  type="file" 
                  accept="image/*,application/pdf"
                  onChange={handleFileChange}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
                {buktiPreview === null ? (
                  <div className="space-y-1">
                    <p className="text-xs font-medium text-gray-600">Klik atau seret nota ke sini</p>
                    <p className="text-[10px] text-gray-400">PNG, JPG, atau PDF (Maks. 2MB)</p>
                  </div>
                ) : (
                  <div className="flex items-center justify-between gap-2 bg-white p-2 rounded-lg border border-gray-100">
                    <div className="flex items-center gap-2 text-left min-w-0">
                      {buktiPreview === "pdf-icon" ? (
                        <div className="w-8 h-8 rounded bg-red-100 text-red-600 flex items-center justify-center font-bold text-[10px]">PDF</div>
                      ) : (
                        <img src={buktiPreview} alt="Preview" className="w-8 h-8 rounded object-cover border shrink-0" />
                      )}
                      <p className="text-xs font-medium text-gray-700 truncate">{budgetForm.bukti_file?.name}</p>
                    </div>
                    <button 
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setBudgetForm({ ...budgetForm, bukti_file: null });
                        setBuktiPreview(null);
                      }}
                      className="text-red-500 text-xs font-medium px-2 py-1 hover:bg-red-50 rounded-lg transition"
                    >
                      Hapus
                    </button>
                  </div>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="w-full mt-2 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-sm rounded-xl transition shadow-sm"
            >
              Simpan & Upload
            </button>
          </form>
        </div>

        {/* SISI KANAN: HISTORY LIST DARI BACKEND */}
        <div className="md:col-span-7 flex flex-col justify-between">
          <div>
            <h4 className="text-sm font-semibold text-gray-700 mb-4 flex items-center justify-between">
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-indigo-500"></span> Riwayat Penggunaan
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                Total Alokasi: {formatRupiah(selectedBudgetEvent.budget)}
              </span>
            </h4>

            {/* AREA UTAMA HISTORY */}
            <div className="space-y-3 max-h-[340px] overflow-y-auto pr-1">
              {isLoadingHistory ? (
                <div className="text-center py-12 text-sm text-gray-400 animate-pulse">
                  Memuat riwayat penggunaan...
                </div>
              ) : budgetHistory.length === 0 ? (
                <div className="text-center py-12 text-sm text-gray-400">
                  Belum ada riwayat penggunaan budget untuk event ini.
                </div>
              ) : (
                budgetHistory.map((hist, index) => (
                  <div key={index} className="p-3 border border-gray-100 rounded-2xl bg-gray-50/50 flex justify-between items-center hover:border-gray-200 transition">
                    <div className="space-y-0.5 min-w-0 pr-3">
                      <div className="flex items-center gap-2">
                        <p className="text-sm font-bold text-gray-800">{formatRupiah(hist.biaya)}</p>
                        <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${
                          hist.type_pembayaran === 'CASH' ? 'bg-emerald-50 text-emerald-700' :
                          hist.type_pembayaran === 'TRANSFER' ? 'bg-blue-50 text-blue-700' :
                          'bg-amber-50 text-amber-700'
                        }`}>
                          {hist.type_pembayaran}
                        </span>
                      </div>
                      <p className="text-xs text-gray-600 truncate">{hist.keterangan}</p>
                      <p className="text-[10px] text-gray-400">
                        {new Date(hist.tanggal).toLocaleDateString("id-ID", {day: 'numeric', month: 'short', year: 'numeric'})} • Toko: {hist.kode_toko}
                      </p>
                    </div>

                    {/* LIHAT FILE BUKTI/NOTA */}
                    <div className="shrink-0">
                      {hist.bukti ? (
                        <a 
                          href={`/uploads/bukti/${hist.bukti}`} // Sesuaikan dengan folder static di backend Anda
                          target="_blank" 
                          rel="noreferrer"
                          className="px-2.5 py-1.5 text-xs font-semibold text-indigo-600 bg-white border border-gray-200 rounded-lg hover:bg-indigo-50 hover:border-indigo-200 transition flex items-center gap-1"
                        >
                          Nota
                        </a>
                      ) : (
                        <span className="text-[10px] text-gray-400 italic">No Bukti</span>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* AKUMULASI TOTAL */}
          <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm mt-4">
            <span className="text-gray-500 font-medium">Total Terpakai saat ini:</span>
            <span className="font-bold text-gray-900 text-base">
              {formatRupiah(budgetHistory.reduce((sum, h) => sum + Number(h.biaya || 0), 0))}
            </span>
          </div>

        </div>

      </div>
      
    </div>
  </div>

  
)}

{/* ========================================================= */}
{/* MODAL BARU: KHUSUS VIEW GALERI FOTO AKTIVITAS (NO UPLOAD) */}
{/* ========================================================= */}
{showViewGalleryModal && (
  <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
    <div className="bg-white rounded-3xl w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh] transform transition-all animate-scaleUp">
      
      {/* HEADER MODAL */}
      <div className="p-5 border-b border-gray-100 flex items-center justify-between bg-gradient-to-r from-gray-50 to-white">
        <div>
          <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <span>📸</span> Galeri Aktivitas
          </h3>
          <p className="text-xs text-indigo-600 font-semibold mt-0.5">
            {viewGalleryEvent?.nama_event}
          </p>
        </div>
        <button 
          onClick={() => {
            setShowViewGalleryModal(false);
            setViewActiveImage(null);
          }}
          className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-400 hover:text-gray-600 font-bold transition text-sm"
        >
          ✕
        </button>
      </div>

      {/* BODY MODAL */}
      <div className="p-6 overflow-y-auto flex-1 bg-gray-50/50">
        {isLoadingGallery ? (
          <div className="flex flex-col items-center justify-center py-12 gap-3">
            <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-xs text-gray-400 font-medium">Memuat foto dokumentasi...</p>
          </div>
        ) : galleryImages.length === 0 ? (
          <div className="text-center py-12">
            <span className="text-3xl">🖼️</span>
            <p className="text-sm text-gray-500 font-medium mt-2">Belum ada foto aktivitas yang diunggah untuk event ini.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {galleryImages.map((img, idx) => (
              <div 
                key={img.id_foto || idx}
                onClick={() => setViewActiveImage(img)}
                className="group relative aspect-video sm:aspect-square bg-gray-100 rounded-2xl overflow-hidden border border-gray-200/60 shadow-sm cursor-zoom-in hover:shadow-md hover:border-indigo-300 transition-all duration-300"
              >
                <img 
                  src={`/api/uploads/aktivitas/${img.nama_file}`} 
                  alt={img.keterangan || "Foto Aktivitas"}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Overlay Keterangan saat Hover */}
                {img.keterangan && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-3 flex items-end">
                    <p className="text-[11px] text-white font-medium line-clamp-2">
                      {img.keterangan}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* FOOTER MODAL */}
      <div className="p-4 border-t border-gray-100 bg-gray-50 flex justify-between items-center text-xs text-gray-400 px-6">
        <span>Total: <b>{galleryImages.length} Foto</b> Terlampir</span>
        <button
          onClick={() => {
            setShowViewGalleryModal(false);
            setViewActiveImage(null);
          }}
          className="bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 px-4 py-2 rounded-xl font-medium transition shadow-sm"
        >
          Tutup
        </button>
      </div>
    </div>
  </div>
)}

{/* ========================================================= */}
{/* SUB-MODAL LIGHTBOX (ZOOM FOTO BESAR SAAT DIKLIK)           */}
{/* ========================================================= */}
{viewActiveImage && (
  <div 
    className="fixed inset-0 z-[1000] bg-black/90 backdrop-blur-md flex flex-col items-center justify-center p-4"
    onClick={() => setViewActiveImage(null)}
  >
    {/* Tombol Close Lightbox */}
    <button className="absolute top-4 right-4 text-white/70 hover:text-white text-xl font-bold bg-white/10 w-10 h-10 rounded-full flex items-center justify-center transition">
      ✕
    </button>

    {/* Frame Foto Utama */}
    <div className="relative max-w-4xl max-h-[75vh] flex items-center justify-center animate-scaleUp" onClick={(e) => e.stopPropagation()}>
      <img 
        src={`/api/uploads/aktivitas/${viewActiveImage.nama_file}`} 
        alt="Preview Besar" 
        className="max-w-full max-h-[75vh] object-contain rounded-xl shadow-2xl border border-white/10"
      />
    </div>

    {/* Teks Keterangan di Bawah Foto */}
    {viewActiveImage.keterangan && (
      <div className="mt-4 max-w-xl text-center bg-white/10 backdrop-blur-md px-4 py-2.5 rounded-2xl border border-white/10">
        <p className="text-white text-xs font-medium leading-relaxed">
          {viewActiveImage.keterangan}
        </p>
      </div>
    )}
  </div>
)}
    </div>
    

    
  );
}